
  <button mat-button [routerLink]="['/manager']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <mat-icon>home</mat-icon>
    <span>Home</span>
  </button>


  <button mat-button [routerLink]="['/manager/account']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <mat-icon>group</mat-icon>
    <span>Accounts</span>
  </button>

  <button mat-button (click)=logout() [routerLink]='' [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>



